export function resolveDockLoadTypes(
  externalLoadTypeIds: string[],
  loadTypeIdsKeyedByExternalId: { [key: string]: string }
) {
  const uniqueExternalIds = externalLoadTypeIds.filter((externalId, index) => {
    return externalLoadTypeIds.indexOf(externalId) === index;
  });
  const getLoadTypeId = (externalId: string) =>
    Object.hasOwn(loadTypeIdsKeyedByExternalId, externalId)
      ? loadTypeIdsKeyedByExternalId[externalId]
      : undefined;
  const loadTypeIds = Array.from(
    new Set(uniqueExternalIds.flatMap(externalId => getLoadTypeId(externalId) ?? []))
  );
  const missingExternalIds = uniqueExternalIds.filter(externalId => !getLoadTypeId(externalId));

  if (externalLoadTypeIds.length === 0) {
    return {
      loadTypeIds,
      failureMessage:
        'A minimum of 1 Load Type is required to create a Dock. If this dock has load types assigned, make sure docks are shared between locations (#6 on location settings)'
    };
  }
  if (missingExternalIds.length > 0) {
    return {
      loadTypeIds,
      failureMessage: `Load Type(s) (${missingExternalIds.join(', ')}) were not imported - see Load Types tab for details`
    };
  }
  return { loadTypeIds, failureMessage: null };
}
